import { useContext } from 'react';

import { WizardContext } from './';

export const useWizard = () => {
  return useContext(WizardContext);
};
